<template>
<w-tool-tabs class="tab-button" size="mini" v-model="activeTab" v-loading="loading">
  <el-row slot="tool" type="flex" justify="end">
    <w-config-edit-tool class="mr-r4" v-show="visibleEditButton"></w-config-edit-tool>
    <!-- 그룹 저장 -->
    <div>
      <el-button v-show="!isConfigEditing && visibleEditButton" type="secondary" size="small" @click="openGroupSavePopup">그룹 저장</el-button>
      <w-group-save-popup ref="groupSavePopup" :selected-obj="selectedNode" :config-data="configData" />
    </div>
  </el-row>
  <el-tab-pane label="구성현황" name="WConfigStatus" >
    <w-config-status :activeTab="activeTab" :nodeParams="params" @setConfigData="setConfigData" />
  </el-tab-pane>
  <el-tab-pane label="쓰레드" name="WThreadInfoNode" >
    <w-thread-info-node :activeTab="activeTab"></w-thread-info-node>
  </el-tab-pane>
  <el-tab-pane label="힙 히스토그램" name="WHeapInfoNode" >
    <w-heap-info-node :activeTab="activeTab"></w-heap-info-node>
  </el-tab-pane>
  <el-tab-pane label="로디드 클래스" name="WLoadedclassInfoNode" >
    <w-loadedclass-info-node :activeTab="activeTab"></w-loadedclass-info-node>
  </el-tab-pane>
  <el-tab-pane label="소켓" name="WSocketInfoNode" >
    <w-socket-info-node :activeTab="activeTab"></w-socket-info-node>
  </el-tab-pane>
  <el-tab-pane label="스냅샷" name="WSnapshotInfoNode" >
    <w-snapshot-info-node :activeTab="activeTab" @load-complete="changeLoadingFlag"></w-snapshot-info-node>
  </el-tab-pane>
  <el-tab-pane label="환경변수" name="WEnvInfoNode" >
    <w-env-info-node :activeTab="activeTab"></w-env-info-node>
  </el-tab-pane>
  <el-tab-pane label="액티브 서비스" name="WActiveSvcInfoNode" >
    <w-active-svc-info-node :activeTab="activeTab"></w-active-svc-info-node>
  </el-tab-pane>
</w-tool-tabs>
</template>

<script>
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import ConfigNodeTab from '@/mixins/config/config-node-tab';
import WLoadedclassInfoNode from './loadedclass';
import WThreadInfoNode from './thread';
import WSocketInfoNode from './socket';
import WEnvInfoNode from './env';
import WHeapInfoNode from './heap';
import WSnapshotInfoNode from './snapshot';
import WActiveSvcInfoNode from './activesvc';
import WConfigStatus from './configstatus';

export default {
  name: 'WConfigApmNode',
  mixins: [ConfigNodeTab],
  components: {
    WLoadedclassInfoNode,
    WThreadInfoNode,
    WSocketInfoNode,
    WEnvInfoNode,
    WHeapInfoNode,
    WSnapshotInfoNode,
    WActiveSvcInfoNode,
    WConfigStatus,
  },
  computed: mapGetters(['selectedNode']),
  data() {
    return {
      activeTab: 'WConfigStatus',
      nodeParams: {},
      params: {
        objId: null,
      },
      configData: {},
      loading: false,
    };
  },
  watch: {
    selectedNode: {
      handler(node) {
        if (!this.active) {
          return;
        }
        if (!isEmpty(node)) {
          this.params.objId = node.obj.objId;
          // this.loadParams();
        }
      },
      immediate: true,
    },
    active(active) {
      if (active) {
        this.params.objId = this.selectedNode.obj.objId;
        // this.loadParams();
      }
    },
  },
  methods: {
    /**
     * 그룹 저장시 데이터 비교할 구성정보 데이터를 바인딩한다.
     * @param  {[type]} configData [description]
     * @author jda
     */
    setConfigData(configData) {
      this.configData = configData;
    },
    /**
     * 탭 전체 v-loading 설정
     * @param  {[type]} flag [description]
     * @return {[type]}      [description]
     * @author jda
     */
    changeLoadingFlag(flag) {
      this.loading = flag;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/apm/index.vue